<div
  (click)="onClickStation($event)"
  [ngClass]="clusterMarkerColorClass()"
  data-testid="CLUSTER_POINT_DIV_WRAPPER_WITH_DATA">
  @let selectedParameterValue = selectedParameter();
  @let markerValueSignal = markerValue();
  @if (markerValueSignal | isNil: false) {
    @if (selectedParameterValue === 'webcam') {
      <img
        data-testid="CLUSTER_POINT_IMG_WEBCAM_PARAMETER"
        mat-card-image
        [src]="markerValueSignal"
        alt="Webcam"
        class="mgl-map__webcam-marker" />
    } @else if (selectedParameterValue === 'road_condition') {
      <div
        class="mgl-map__marker-text"
        data-testid="CLUSTER_POINT_DIV_ROAD_CONDITION_PARAMETER">
        {{
          'MAPPING.GMA_ROAD_CONDITION_SHORT.' + markerValueSignal | translate
        }}
      </div>
    } @else if (selectedParameterValue === 'gmaAlarm') {
      <ng-container
        *ngTemplateOutlet="
          gmaAlarmValue;
          context: {
            $implicit: markerValueSignal,
          }
        "></ng-container>
    } @else if (
      selectedParameterValue === 'ff' || selectedParameterValue === 'fx'
    ) {
      <div
        class="mgl-map__marker-text"
        data-testid="CLUSTER_POINT_DIV_FF_AND_FX_PARAMETERS">
        @let markerPropertiesValue = markerProperties();
        @if (!(markerPropertiesValue?.dd | isNil)) {
          <div
            [ngStyle]="{
              transform: 'rotate(' + markerPropertiesValue.dd + 'deg)',
            }"
            style="margin-top: -6px; margin-bottom: -8px"
            data-testid="CLUSTER_POINT_DIV_DD_PARAMETER">
            <fa-icon [icon]="['far', 'long-arrow-down']"></fa-icon>
          </div>
        }
        {{ markerValueSignal * 1.852 | round }}
      </div>
    } @else if (selectedParameterValue === 'vv') {
      <div
        class="mgl-map__marker-text"
        data-testid="CLUSTER_POINT_DIV_VV_PARAMETER">
        {{ markerValueSignal / 1000 | round }}
      </div>
    } @else if (
      selectedParameterValue === 'rh' || selectedParameterValue === 'hcl'
    ) {
      <div
        class="mgl-map__marker-text"
        data-testid="CLUSTER_POINT_DIV_RH_AND_HCL_PARAMETER">
        {{ markerValueSignal | round }}
      </div>
    } @else if (selectedParameterValue === 'ww') {
      <img
        height="42"
        style="vertical-align: middle"
        data-testid="CLUSTER_POINT_IMG_WW_PARAMETER"
        [src]="
          './assets/symbols/wm/64x64/' +
          (markerValueSignal | weatherCondition) +
          '.png'
        " />
    } @else if (
      selectedParameterValue === 'n' || selectedParameterValue === 'nlow'
    ) {
      <img
        height="28"
        style="vertical-align: middle; margin-top: 1px"
        data-testid="CLUSTER_POINT_IMG_N_AND_NLOWs_PARAMETERS"
        [src]="
          './assets/symbols/N_TotalCloudCover/' +
          (markerValueSignal | coverage) +
          '.svg'
        " />
    } @else {
      <div
        class="mgl-map__marker-text"
        data-testid="CLUSTER_POINT_DIV_DEFAULT_PARAMETER">
        {{ markerValueSignal | number: '0.1-1' }}
      </div>
    }
  } @else {
    <div
      class="mgl-map__marker-text"
      data-testid="CLUSTER_POINT_DIV_WRAPPER_WITHOUT_DATA">
      --
    </div>
  }
</div>

<ng-template #gmaAlarmValue let-value>
  @let getGmaAlarmMarkerColorFnValue = getGmaAlarmMarkerColorFn();
  <fa-layers size="lg">
    <fa-icon
      [icon]="['fas', 'triangle']"
      transform="down-2 left-2"
      data-testid="CLUSTER_POINT_FA_ICON_ALARM_PARAMETER_ICON"
      [ngStyle]="{
        color: value | memoize: getGmaAlarmMarkerColorFnValue,
      }"></fa-icon>
    <fa-layers-text
      [content]="value"
      transform="down-5"
      size="sm"
      style="color: white"></fa-layers-text>
  </fa-layers>
</ng-template>
